import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

const DascartDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dascart-dashboard"*/ '../../pages/dascart-dashboard'
    ),
);

const DasCartDashboardRouter = (
  <Route path="dascart-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="dascart-dashboard"
            component={<DascartDashboardComponent />}
          />
        </Suspense>
      }
    />
  </Route>
);

export default DasCartDashboardRouter;
